import { render, staticRenderFns } from "./PayPartner.vue?vue&type=template&id=1694c868&lang=pug"
import script from "./PayPartner.vue?vue&type=script&lang=js"
export * from "./PayPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports